import axios from 'axios';
import { deleteToken } from '@iso/lib/helpers/localStorage';
import swal from 'sweetalert';

const BASE_API_URL = import.meta.env.VITE_APP_API_KEY || 'http://localhost:6880'

const NOT_FOUND_ERROR_CODES = new Set([
    'CUSTOMER_NOT_FOUND',
    'PRODUCT_NOT_FOUND',
    'ORDER_NOT_FOUND',
    'VAT_INVOICE_NOT_FOUND',
    'TRANSFER_VOUCHER_NOT_FOUND',
    'IMPORT_VOUCHER_NOT_FOUND',
]);

export const api = axios.create({
    baseURL: BASE_API_URL,
    timeout: 30000,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
    },
});

export function axiosDownload(url, method, model = null, data = null) {
    return {
        baseURL: url,
        method: method,
        timeout: 0,
        responseType: "blob",
        headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: localStorage.getItem("USER_TOKEN") === null ? null : `Bearer ${localStorage.getItem("USER_TOKEN")}`,
        },
        params: model,
        data: data,
        onDownloadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total); // you can use this to show user percentage of file downloaded
            console.log(percentCompleted);
        }
    };
  };

api.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        const { response } = error;
        if (!response) {
            return Promise.reject(error);
        }
        const { status, data } = response;
        const apiError = data?.error;
        if (status === 401) {
            deleteToken();
            window.location.href = "/signin";
        }
        if (status === 403 && !apiError?.code) {
            window.location.href = "/403";
        }
        if (NOT_FOUND_ERROR_CODES.has(apiError?.code)) {
            apiError.isSweetAlertShown = true;
            swal({
                title: "Thông báo lỗi",
                text: apiError.message || "Dữ liệu không tồn tại.",
                icon: "error",
                buttons: [false, "Ok"],
            });
        }
        if (status === 426) {
            swal({
                title: "Thông báo",
                text: "Có sự thay đổi về hệ thống, vui lòng đăng nhập lại.",
                icon: "info",
                buttons: [false, "Ok"],
            }).then((value) => {
                deleteToken();
                window.location.href = "/signin";
            });;
        }
        return Promise.reject(error);
    }
);

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('USER_TOKEN');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

export function setAuthorization(token) {
    if (token) {
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
        delete api.defaults.headers.common['Authorization'];
    }
}

export function removeAuthorization() { //for Logout
    setAuthorization(null)
}
